import { render } from "./RiskAnalysisDashboard.vue?vue&type=template&id=f613fe1c&scoped=true"
import script from "./RiskAnalysisDashboard.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisDashboard.vue?vue&type=script&lang=js"

import "./RiskAnalysisDashboard.vue?vue&type=style&index=0&id=f613fe1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f613fe1c"]])

export default __exports__